import React, { useState, useLayoutEffect, useEffect, useRef} from 'react';
import { useQueryClient } from '@tanstack/react-query';
import debounce from "lodash.debounce"; // Prevent excessive redraws

import Hexagon from './Hexagon';
import Rhombus from './Rhombus';
import Rectangle from './Rectangle';

import jsPDF from 'jspdf';

//import Button from 'react-bootstrap/Button';
import { CirclePicker } from "react-color";
//import { CompactPicker } from "react-color";
//import { Popover, MenuItem, Menu } from '@mui/material';
import { ControlledMenu, FocusableItem, MenuItem, SubMenu } from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';

import { Menu as MuiMenu, MenuItem as MuiMenuItem, IconButton, TextField, Autocomplete, Typography, Box } from '@mui/material';

//import Button from '@mui/material/Button';
import { Stage, Layer, Text, Group, Rect, Image } from 'react-konva';
import useImage from 'use-image'; // for loading images
import dottedGrid from '../../assets/images/dottedgrid.png';
import { ReactComponent as HexagonPreview } from '../../assets/images/preview-hexagon.svg';
import { ReactComponent as RhombusOneButtonPreview } from '../../assets/images/preview-rhombus1.svg';
import { ReactComponent as RhombusTwoButtonsPreview } from '../../assets/images/preview-rhombus2.svg';
import { ReactComponent as RectanglePreview } from '../../assets/images/preview-rectangle.svg';

import { ListItemIcon, ListItemText } from '@mui/material';
import {
  RotateRight,
  Delete,
  Palette,
  LinkOff as LinkOffIcon,
  ZoomIn,
  ZoomOut,
  CenterFocusStrong,
  GetAppRounded as GetAppRoundedIcon,
  AddCircleRounded as AddCircleRoundedIcon,
  ModeCommentRounded as ModeCommentRoundedIcon,
  Visibility as VisibilityIcon,
  AdsClick as AdsClickIcon,
  VisibilityOff as VisibilityOffIcon
} from '@mui/icons-material';

//import GetAppRoundedIcon from '@mui/icons-material/GetAppRounded';
//import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';

//import ModeCommentRoundedIcon from '@mui/icons-material/ModeCommentRounded';

import { useAppData } from "../../hooks/useAppData";
import { useAppStore } from "../../hooks/useAppStore";

//import { useData } from '../../contexts/DataContext';
import { useHover } from '../../contexts/HoverContext';

//import WordListBoard from '../WordList/WordListBoard';

import { useStyle } from '../../contexts/StyleContext'; 
import { useNotification } from '../../contexts/NotificationContext'; 
import { useTranslation, Trans } from 'react-i18next'; 
import { getRandomColor, colorOptions, calculateNextButtonLabel } from '../../utils/helpers';

const SNAP_THRESHOLD = 10; // Define a threshold for snapping
const TILE_SIZE = 100; // Adjust according to the size of the image

const Soundboard = () => {
  const { t } = useTranslation(); 
  const { showNotification } = useNotification();
  

  const [stageBackgroundImage] = useImage(dottedGrid);
  const queryClient = useQueryClient();

  const { 
    stageRef, 
    handleHoverLeave,
    isDraggingWord,
    draggedWordId, 
    setDraggedWordPosition
  } = useHover() || {};

  /*const { 
    //wordList, 
    //getWordList,
    //updateWordList, 
    //shapes, 
    //setShapes, 
    //addShape, 
    //updateShape, 
    //updateButton,
    //handleOptionChange,
    //calculateNextButtonLabel,
    //getRandomColor,
    //colorOptions,
    //deleteShape, 
    //getSoundboard, 
    //stageWidth,
    //setStageWidth,
    //stageHeight,
    //setStageHeight,
    //assignedWordTooltipVisibility,
    //handleAssignedWordTooltipVisibility,
    //unassignButton,
    //buttonPopovers,
    //setButtonPopovers,
    //shapePopovers,
    //setShapePopovers,
    //selectedItem,
    //setSelectedItem,
    //wordListWidth,
    //setWordListWidth
  } = useData() || {};*/

  const { 
      wordList, 
      isWordListPending,
      isWordListError, 
      wordListRefetch,
      updateWordList,
      updateWordListOnReorder,
      addGroup,
      deleteGroup,
      addWordItem,
      deleteWord,
      soundboard,
      shapes,
      isSoundboardPending,
      isSoundboardError, 
      soundboardRefetch,
      addShape,
      updateShape,
      updateButton,
      unassignButton,
      deleteShape,
      handleOptionChange,
      handleAssignedWordTooltipVisibility,
      assignedWordTooltipVisibility
    } = useAppData();
    
    const { 
      wordListId, setWordListId, 
      soundboardId, setSoundboardId,
      stageWidth, setStageWidth,
      stageHeight, setStageHeight,
      stagePos, setStagePos,
      stageScale, setStageScale,
      relativeCenter, setRelativeCenter,
      buttonPopovers, setButtonPopovers,
      shapePopovers, setShapePopovers,
      selectedItem, setSelectedItem,
      wordListWidth, setWordListWidth,
      lastUsedShapeColor, setLastUsedShapeColor,
      lastUsedButtonColor, setLastUsedButtonColor
    } = useAppStore();


  const { 
    tooltipPadding,
    tooltipCornerRadius,
    tooltipFontSize,
    tooltipBackgroundColor, 
    tooltipTextColor,
    fontPrimary
  } = useStyle() || {};

  const [currentStageWidth, setCurrentStageWidth] = useState(stageWidth);

  const [isDraggingShape, setIsDraggingShape] = useState(false);
  //const [draggedShapeId, setDraggedShapeId] = useState(null); 
  let initialShapePosition = { x: 0, y: 0 };

  const [lastDist, setLastDist] = useState(0); // Store the distance between fingers for pinch zoom
  
  const [isDraggingStage, setIsDraggingStage] = useState(false);

  const getSnapPoints = (shape) => {
    const {
      shapeType,
      x: shapeX,
      y: shapeY,
      rotation,
      radius,
      sideWidth,
      sideHeight,
    } = shape;
    const rotationRad = (rotation || 0) * (Math.PI / 180);
    let adjustedShapeX = 0;
    let adjustedShapeY = 0;

    switch (shapeType) {
      case 'hexagon':
      // No offset adjustments needed as per the Hexagon component
      // The Hexagon is centered at (shapeX, shapeY)
      const vertices = new Array(6).fill().map((_, i) => {
        const angleRad = (Math.PI / 3 * i) + (Math.PI / 6);
        const rotatedX = radius * Math.cos(angleRad + rotationRad);
        const rotatedY = radius * Math.sin(angleRad + rotationRad);

        return {
          x: shapeX + rotatedX,
          y: shapeY + rotatedY,
        };
      });

      const edgeMidpoints = vertices.map((vertex, i) => {
        const nextVertex = vertices[(i + 1) % 6];
        const midpoint = {
          x: (vertex.x + nextVertex.x) / 2,
          y: (vertex.y + nextVertex.y) / 2,
        };
        return midpoint;
      });

        return { vertices, midpoints: edgeMidpoints };

      case 'rectangle':
        const centerX = sideWidth / 2;
        const centerY = sideHeight / 2;
  
        // Adjust shapeX and shapeY to account for offset
        adjustedShapeX = shapeX - centerX;
        adjustedShapeY = shapeY - centerY;
  
        const rectangleVertices = [
          { x: -centerX, y: -centerY },
          { x: centerX, y: -centerY },
          { x: centerX, y: centerY },
          { x: -centerX, y: centerY },
        ].map((vertex) => {
          const rotatedX = vertex.x * Math.cos(rotationRad) - vertex.y * Math.sin(rotationRad);
          const rotatedY = vertex.x * Math.sin(rotationRad) + vertex.y * Math.cos(rotationRad);
  
          return {
            x: adjustedShapeX + rotatedX + centerX,
            y: adjustedShapeY + rotatedY + centerY,
          };
        });
  
        const rectangleEdgeMidpoints = rectangleVertices.map((vertex, i) => {
          const nextVertex = rectangleVertices[(i + 1) % 4];
          return {
            x: (vertex.x + nextVertex.x) / 2,
            y: (vertex.y + nextVertex.y) / 2,
          };
        });
  
        return { vertices: rectangleVertices, midpoints: rectangleEdgeMidpoints };
  
      case 'rhombus':
        const offsetX = sideWidth / 2;
        const offsetY = 0;
        const rhombusHeight = Math.sin(Math.PI / 3) * sideWidth;
        adjustedShapeX = shapeX - offsetX;
        adjustedShapeY = shapeY - offsetY;
  
        const rhombusVertices = [
          { x: -offsetX, y: 0 },
          { x: 0, y: rhombusHeight },
          { x: offsetX, y: 0 },
          { x: 0, y: -rhombusHeight },
        ].map((vertex) => {
          const rotatedX = vertex.x * Math.cos(rotationRad) - vertex.y * Math.sin(rotationRad);
          const rotatedY = vertex.x * Math.sin(rotationRad) + vertex.y * Math.cos(rotationRad);
  
          return {
            x: adjustedShapeX + rotatedX + offsetX,
            y: adjustedShapeY + rotatedY + offsetY,
          };
        });
  
        const rhombusEdgeMidpoints = rhombusVertices.map((vertex, i) => {
          const nextVertex = rhombusVertices[(i + 1) % 4];
          return {
            x: (vertex.x + nextVertex.x) / 2,
            y: (vertex.y + nextVertex.y) / 2,
          };
        });
  
        return { vertices: rhombusVertices, midpoints: rhombusEdgeMidpoints };
  
      // Include the existing code for 'hexagon' and other shapes if any
      default:
        return { vertices: [], midpoints: [] };
    }
  };
  

  const handleDragStart = (shapeId, e) => {
    setIsDraggingShape(true);
    
    // Also disable stage dragging (just in case)
    const stage = e.target.getStage();
    stage.draggable(false);
  };

  const handleDragMove = (shapeId, e) => {
    let { x, y } = e.target.position();


    // 2️⃣ If mobile (touch event), override with Konva’s pointer position
    if (e.evt.touches?.length > 0) {
      const pointerPos = e.target.getStage().getPointerPosition();
      if (pointerPos) {
        x = pointerPos.x;
        y = pointerPos.y;
      }
    }

    let closestSnapPoint = null;
    let minDistance = SNAP_THRESHOLD;

    // Calculate the vertices for the current shape based on its new position
    const currentShape = shapes.find(shape => shape._id === shapeId);
    const currentSnapPoints = getSnapPoints({
      ...currentShape,
      x: x - centerX,
      y: y - centerY,
    });

    shapes.forEach(shape => {
      if (shape._id !== shapeId) { // Don't compare to the shape being dragged
        const snapPoints = getSnapPoints(shape);

        snapPoints.midpoints.forEach(point => {
          currentSnapPoints.midpoints.forEach(currentPoint => {
            const distance = Math.hypot(point.x - currentPoint.x, point.y - currentPoint.y);
            if (distance < minDistance) {
              minDistance = distance;
              closestSnapPoint = {
                x: point.x,
                y: point.y,
                offsetX: currentPoint.x - point.x,
                offsetY: currentPoint.y - point.y,
              };
            }
          });
        });
      }
    });

    if (closestSnapPoint) {
      // Snap to the closest snap point
      e.target.position({
        x: x - closestSnapPoint.offsetX,
        y: y - closestSnapPoint.offsetY,
      });
    } else {
      // No snap point is close enough, keep the original position
      e.target.position({
        x,
        y,
      });
    }
  
    // Manually update the tooltips during the drag based on the updated position
    updateTooltipsDuringDrag(shapeId, x, y);

  };


  const handleDragEnd = (shapeId, e) => {
    const { x, y } = e.target.position();
    // Update the shape's position on the server or global state
    updateShape.mutate({
      shapeId,
      updates: [
        { field: 'x', value: x - stageWidth / 2 },
        { field: 'y', value: y - stageHeight / 2 }
      ]
    });
    // Update tooltips after dragging
    updateTooltips();

    //setDraggedShapeId(null); // Reset the dragged shape ID
    setIsDraggingShape(false);

      // Re-enable stage dragging
      const stage = e.target.getStage();
      stage.draggable(true);
  };


  const parentDivRef = useRef(); // Ref for the parent div
  //const stageRef = useRef(); // Ref for the stage div konvaStageRef
  const buttonRowRef = useRef(null);

  const centerX = stageWidth / 2;
  const centerY = stageHeight / 2;
  

  const dropdownRef = useRef(null); // Add this line

  const [hoveredItem, setHoveredItem] = useState({ type: null, id: null });
  const [tooltips, setTooltips] = useState([]);
  //const [tooltip, setTooltip] = useState({ visible: false, text: '', x: 0, y: 0 });

  /** Shape popover **/

  /** Button popover **/
  //const [inputValue, setInputValue] = useState('');
  // Ref to track the stage container. Different to stageRef. Used to track stage for individual Popover
  const stageContainerRef = useRef(null);


  const selectedOption = null;

  /*
  function getRandomColor() {
    const randomIndex = Math.floor(Math.random() * colorOptions.length);
    return colorOptions[randomIndex];
  }*/

  /** Pan, zoom, recenter **/

  // Function to draw the tiled background by repeating the image
  const drawTiledBackground = () => {
    if (!stageBackgroundImage) return null; // Return early if the image isn't loaded yet

    const scale = stageScale;
    const position = stagePos;
  
    // Calculate the visible area in the unscaled stage coordinates
    const left = -position.x / scale;
    const right = (-position.x + stageWidth) / scale;
    const top = -position.y / scale;
    const bottom = (-position.y + stageHeight) / scale;
  
    // Calculate the start and end positions for tiling
    const startX = Math.floor(left / TILE_SIZE) * TILE_SIZE;
    const endX = Math.ceil(right / TILE_SIZE) * TILE_SIZE;
    const startY = Math.floor(top / TILE_SIZE) * TILE_SIZE;
    const endY = Math.ceil(bottom / TILE_SIZE) * TILE_SIZE;
  
    const imageComponents = [];
  
    // Create the tiles without manually scaling them—let the Stage handle zoom
    for (let x = startX; x < endX; x += TILE_SIZE) {
      for (let y = startY; y < endY; y += TILE_SIZE) {
        imageComponents.push(
          <Image
            key={`tile-${x}-${y}`}
            x={x}
            y={y}
            width={TILE_SIZE}
            height={TILE_SIZE}
            image={stageBackgroundImage}
            listening={false} // Background won't block interactions
          />
        );
      }
    }
  
    return imageComponents;
  };

  const handleZoomIn = () => {
    const stage = stageRef.current;
    if (!stage) return; // Ensure stage is available

    const oldScale = stage.scaleX();
    const newScale = oldScale * 1.1; // Adjust zoom factor
    const pointer = stage.getPointerPosition();
    if (!pointer) return; // Prevent crash if pointer is null

    const mousePointTo = {
      x: (pointer.x - stage.x()) / oldScale,
      y: (pointer.y - stage.y()) / oldScale,
    };
  
    const newPos = {
      x: pointer.x - mousePointTo.x * newScale,
      y: pointer.y - mousePointTo.y * newScale,
    };
  
    stage.scale({ x: newScale, y: newScale });
    stage.position(newPos);
    setStagePos(newPos); // Update the stage position state
    setStageScale(newScale); // Update the zoom level (scale)

    setRelativeCenter((prevCenter) => ({
      x: (prevCenter.x * oldScale - newPos.x) / newScale,
      y: (prevCenter.y * oldScale - newPos.y) / newScale,
    }));

    stage.batchDraw();
    
  };
  
  const handleZoomOut = () => {
    const stage = stageRef.current;
    if (!stage) return; // Ensure stage is available

    const oldScale = stage.scaleX();
    const newScale = oldScale / 1.1; // Adjust zoom factor
    const pointer = stage.getPointerPosition();
    if (!pointer) return; // Prevent crash if pointer is null

    const mousePointTo = {
      x: (pointer.x - stage.x()) / oldScale,
      y: (pointer.y - stage.y()) / oldScale,
    };
  
    const newPos = {
      x: pointer.x - mousePointTo.x * newScale,
      y: pointer.y - mousePointTo.y * newScale,
    };
  
    stage.scale({ x: newScale, y: newScale });
    stage.position(newPos);
    setStagePos(newPos); // Update the stage position state
    setStageScale(newScale); // Update the zoom level (scale)

    setRelativeCenter((prevCenter) => ({
      x: (prevCenter.x * oldScale - newPos.x) / newScale,
      y: (prevCenter.y * oldScale - newPos.y) / newScale,
    }));

    stage.batchDraw();
  };

  const handleRecenter = () => {
    const stage = stageRef.current;

    stage.position({ x: 0, y: 0 }); // Default position
    stage.scale({ x: 1, y: 1 }); // Default zoom level
    setStagePos({ x: 0, y: 0 }); // Update the stage position state
    setStageScale( 1 ); // Update the zoom level (scale)
    stage.batchDraw();
  };

  // Handle Trackpad or Mouse Wheel for Zoom
  const handleWheel = (e) => {
    e.evt.preventDefault();

    const stage = stageRef.current;
    const scaleBy = 1.05;
    const oldScale = stage.scaleX();
    const pointer = stage.getPointerPosition();
  
    const mousePointTo = {
      x: (pointer.x - stage.x()) / oldScale,
      y: (pointer.y - stage.y()) / oldScale,
    };
  
    // Fix: Invert the condition for zooming
    const newScale = e.evt.deltaY < 0 ? oldScale * scaleBy : oldScale / scaleBy;
    stage.scale({ x: newScale, y: newScale });
    setStageScale(newScale); //keeping track for infinite background zoom-in/out
  
    const newPos = {
      x: pointer.x - mousePointTo.x * newScale,
      y: pointer.y - mousePointTo.y * newScale,
    };
    setStagePos(newPos); //keeping track for infinite background zoom-in/out
  
    stage.position(newPos);
    stage.batchDraw();
  };

  /*const handlePointerMove = (e) => {
    console.log('📌 handlePointerMove fired'); // Check if this logs

    if (!isDraggingWord || !draggedWordId) {
        console.log('Skipping: No word is being dragged.');
        return;
    }

    const stage = e.target.getStage();
    if (!stage) {
        console.log('No stage detected');
        return;
    }

    const pointerPos = stage.getPointerPosition();
    console.log('Pointer Pos:', pointerPos);

    if (!pointerPos) return;

    setDraggedWordPosition({ x: pointerPos.x, y: pointerPos.y });
  };*/

  // Mouse drag for Pan
  const handleMouseDown = (e) => {
    setIsDraggingStage(true);
    const stage = stageRef.current;
    stage.container().style.cursor = 'grabbing';
  };

  const handleMouseMove = (e) => {
    if (!isDraggingStage) return;

    const stage = stageRef.current;
    const pointer = stage.getPointerPosition();
    const position = stage.position();

    stage.position({
      x: position.x + (pointer.x - stage.getPointerPosition().x),
      y: position.y + (pointer.y - stage.getPointerPosition().y),
    });

    stage.batchDraw();
  };

  const handleMouseUp = () => {
    setIsDraggingStage(false);
    const stage = stageRef.current;
    stage.container().style.cursor = 'default';
  };

  
  /** End of pan, zoom, recenter */

  // State and handlers for "Add Panel" menu
  const [menuAnchorElAddPanel, setMenuAnchorElAddPanel] = React.useState(null);

  const handleOpenMenuAddPanel = (event) => {
    setMenuAnchorElAddPanel(event.currentTarget);
  };
  
  const handleCloseMenuAddPanel = () => {
    setMenuAnchorElAddPanel(null);
  };

  const handleMenuItemClickAddPanel = (selectedShape, buttonLayout, e) => {
    handleAddShape(selectedShape, buttonLayout, e);
    handleCloseMenuAddPanel();
  };
  // State and handlers for "Tooltip visibility" menu
  const [anchorElTooltip, setAnchorElTooltip] = useState(null);
  const handleOpenMenuTooltip = (event) => {
    setAnchorElTooltip(event.currentTarget);
  };
  const handleCloseMenuTooltip = () => {
    setAnchorElTooltip(null);
  };
  const handleMenuItemClickTooltip = (newVisibility) => {
    handleAssignedWordTooltipVisibility.mutate(newVisibility);
    handleCloseMenuTooltip();
  };
  
  // Map state values to human-readable labels
  const visibilityOptions = {
    show: {
      icon: <VisibilityIcon />,
      label: t('soundboard.tooltipVisibilityShowLabel'),
    },
    hover: {
      icon: <AdsClickIcon />,
      label: t('soundboard.tooltipVisibilityHoverLabel'),
    },
    hide: {
      icon: <VisibilityOffIcon />,
      label: t('soundboard.tooltipVisibilityHideLabel'),
    },
  };
  /*const handleToggleAssignedWordTooltipVisibility = (e) => {
    const newVisibility = e.target.value;
    handleAssignedWordTooltipVisibility(newVisibility);
  };*/
  

  // Handlers to be passed down
  const handleMouseEnterPanel = (shapeId) => {
    setHoveredItem({ type: 'panel', id: shapeId });
  };
  
  const handleMouseLeavePanel = () => setHoveredItem({ type: null, id: null });
  
  const handleMouseEnterButton = (buttonId, e) => {
    if (assignedWordTooltipVisibility === 'hover') { 
      const bounds = e.target.getStage().container().getBoundingClientRect();
      //const x = e.evt.clientX - bounds.left; // Relative to stage. doesn't work with zoom-in/out
      //const y = e.evt.clientY - bounds.top // Relative to stage

      const x = (stageRef.current.getPointerPosition().x-stagePos.x)/stageScale;
      const y = (stageRef.current.getPointerPosition().y-stagePos.y)/stageScale;

      setHoveredItem({ type: 'button', id: buttonId });
      const word = wordList.flatMap(group => group.wordItems).find(wordItem => wordItem.buttonId === buttonId)?.text;
      if (word) { // Only set tooltip if there is a word
        const newTooltip = {
          buttonId,
          visible: true,
          text: word,
          x: x,
          y: y
        };
        setTooltips([newTooltip]); // Only keep one tooltip for hover
      } else {
        setTooltips([]); // Clear tooltip if no word
      }
    }
  };
  
  const handleMouseLeaveButton = (shapeId) => {
    if (assignedWordTooltipVisibility === 'hover') { 
      setHoveredItem({ type: 'panel', id: shapeId });
      setTooltips([]); // Hide tooltip on mouse leave
    }
  };


//Calculate button positions to place assigned word tooltips correctly
const calculateButtonPositionsForTooltips = (shape) => {
  const { shapeType, x: shapeX, y: shapeY, radius, sideWidth, sideHeight, rotation, buttonLayout } = shape;
  const rotationRad = (rotation || 0) * (Math.PI / 180); // Calculate rotation in radians

  // Offsets applied to the shape/group
  let offsetX = 0;
  let offsetY = 0;

  switch (shapeType) {
    case 'hexagon':
      offsetX = 0;
      offsetY = 0;

      const buttonPositions = shape.buttons.map((button, i) => {
        if (!button) return null; // Skip undefined buttons

        if (i === 0) {
          // Center button
          return {
            ...button,
            x: centerX + shapeX,
            y: centerY + shapeY,
            radius: button.radius || 10,
          };
        }

        const offsetAngleRad = Math.PI / 6; // 30 degrees in radians
        const angleRad = offsetAngleRad + (Math.PI / 3 * (i - 1)) + (rotation || 0) * (Math.PI / 180); // 60 degrees in radians + rotation
        const bx = centerX + shapeX + (radius - 30) * Math.cos(angleRad);
        const by = centerY + shapeY + (radius - 30) * Math.sin(angleRad);

        return {
          ...button,
          x: bx,
          y: by,
          radius: button.radius || 10,
        };
      });

      return buttonPositions.filter(button => button !== null); // Filter out any null buttons

    case 'rhombus':
      offsetX = sideWidth / 2;
      offsetY = 0;

        const rhombusHeight = Math.sqrt(3) / 2 * sideWidth;
        const rhombusButtonPositions = shape.buttons.map((button, i) => {
          if (!button) return null; // Skip undefined buttons
  
          /*if (i === 0) {
            return {
              ...button,
              x: centerX + shapeX,
              y: centerY + shapeY - rhombusHeight / 2,
              radius: button.radius || 10,
            };
          }*/
          let bx, by;
          if (buttonLayout === 'one-button') {
            // Center button
            bx = sideWidth / 2;
            by = 0;
          } else {
            // Two-button layout
            if (i === 0) {
              // Top vertex button
              bx = sideWidth / 2;
              by = -rhombusHeight / 2;
            } else {
              // Bottom vertex button
              bx = sideWidth / 2;
              by = rhombusHeight / 2;
            }
          }
  
        // Adjust for offset
        bx -= offsetX;
        by -= offsetY;

         // Rotate the positions based on the rhombus's rotation
        const rotatedX = bx * Math.cos(rotationRad) - by * Math.sin(rotationRad);
        const rotatedY = bx * Math.sin(rotationRad) + by * Math.cos(rotationRad);

          return {
            ...button,
            x: centerX + shapeX + rotatedX,
            y: centerY + shapeY + rotatedY,
            radius: button.radius || 10,
          };
        });
  
        return rhombusButtonPositions.filter(button => button !== null);

      case 'rectangle':
        offsetX = sideWidth / 2;
        offsetY = sideHeight / 2;

        const buttonPositionsRectangle = shape.buttons.map((button, i) => {
          if (!button) return null; // Skip undefined buttons
  
          // Calculate the initial position of the button relative to the rectangle center
          const bx = (sideWidth/2) - offsetX;
          const by = (sideHeight/2) -offsetY;
  
          // Rotate the positions based on the rectangle's rotation
          const rotatedX = bx * Math.cos(rotationRad) - by * Math.sin(rotationRad);
          const rotatedY = bx * Math.sin(rotationRad) + by * Math.cos(rotationRad);
  
          // Translate the positions based on the shape's position
          return {
            ...button,
            x: centerX + shapeX + rotatedX,
            y: centerY + shapeY + rotatedY,
            radius: button.radius || 10,
          };
        });
  
        return buttonPositionsRectangle.filter(button => button !== null);
  
    default:
      return [];
  }

};

  //Update tooltips location
  const updateTooltips = () => {
    if (!wordList || !Array.isArray(wordList)) {
      return; // Prevents crash by exiting early, otherwise updateTooltips might run before wordList is loaded asynchronously
  }
    if (assignedWordTooltipVisibility === 'show') {
      const newTooltips = [];
      wordList.forEach(group => {
        if (!group.wordItems) return; // ✅ Prevents further issues
          group.wordItems.forEach(wordItem => {
            if (wordItem.buttonId) {
              const shape = shapes.find(shape => 
                shape.buttons.some(button => button._id === wordItem.buttonId)
              );

              if (shape) {
                const buttonPositions = calculateButtonPositionsForTooltips(shape);
                const button = buttonPositions.find(btn => btn._id === wordItem.buttonId);

                newTooltips.push({
                  buttonId: wordItem.buttonId,
                  visible: true,
                  text: wordItem.text,
                  x: button.x,
                  y: button.y,
                });
              }
          }
        });
      });
      setTooltips(prevTooltips => {
        if (JSON.stringify(prevTooltips) === JSON.stringify(newTooltips)) return prevTooltips; // ✅ Prevents unnecessary updates
        return newTooltips;
      });
    } else {
      setTooltips(prevTooltips => {
        if (prevTooltips.length === 0) return prevTooltips; // ✅ Prevents unnecessary updates
        return [];
      });
      //setTooltips([]);
    }
  };

  const updateTooltipsDuringDrag = (shapeId, x, y) => {
    if (assignedWordTooltipVisibility === 'show') {
      const newTooltips = tooltips.map(tooltip => {
        // Find the shape being dragged, update its tooltip position
        const shape = shapes.find(shape => 
          shape._id === shapeId && 
          shape.buttons.some(button => button._id === tooltip.buttonId)
        );
  
        if (shape) {
          // Calculate new position only for the tooltip related to the dragged shape
          const buttonPositions = calculateButtonPositionsForTooltips({
            ...shape,
            x: x - centerX,
            y: y - centerY, // Use updated x and y from the drag event
          });
          const button = buttonPositions.find(btn => btn._id === tooltip.buttonId);
  
          if (button) {
            // Update the dragged shape's tooltip position
            return {
              ...tooltip,
              x: button.x,
              y: button.y,
            };
          }
        }
  
        // For other tooltips, keep their positions unchanged
        return tooltip;
      });
  
      // Update the tooltips state
      setTooltips(newTooltips);
    }
  };
  
  /**Measure text width for aasigned word tooltip */
  function measureTextWidth(text, fontSize) {
    const context = document.createElement('canvas').getContext('2d');
    context.font = `${fontSize}px ${fontPrimary}`; // Use the same font and size as in the Konva Text component
    return context.measureText(text).width;
  };

  // Function to handle the addition of a new shape
  const handleAddShape = (shapeType, buttonLayout, e) => {
    e.cancelBubble = true;

    if (stageRef.current) {
      const stage = stageRef.current;
      const stageWidth = stage.width();
      const stageHeight = stage.height();
      const stagePos = stage.getRelativePointerPosition(); // Relative x,y of mouse click

      /*const toolbarRect = buttonRowRef.current.getBoundingClientRect(); // Toolbar div
      const stageRect = stage.container().getBoundingClientRect(); // Stage div
      const scale = stage.scaleX(); // Scale based on zoom, also stageScale state
      const stageX = stage.x(); // Current pan X
      const stageY = stage.y(); // Current pan Y
      const toolbarCenterX = toolbarRect.left + toolbarRect.width / 2; // Horizontal center of toolbar relative to browswer coordinates
      const toolbarBottomY = toolbarRect.bottom; // Bottom of toolbar relative to browswer coordinates
      */
      //const stageAbsolutePos = stage.position();
      //const adjustedX = stagePos.x / window.devicePixelRatio;
      //const adjustedY = stagePos.y / window.devicePixelRatio;

      //let shapeX = (stagePos.x - (stageWidth/2)); 
      //let shapeY = (stagePos.y - (stageHeight/2))+(160/window.devicePixelRatio);

      let shapeX, shapeY;

      if (stagePos) {
        shapeX = stagePos.x - stageWidth / 2;//where mouse clicked, adjusted for (0,0) as center, plus a slight offset so new shape isn't underneath the panel
        shapeY = stagePos.y - stageHeight / 2 + (160 / window.devicePixelRatio);
      } else {
        // fallback: center of stage
        shapeX = 0;
        shapeY = 0;
      }

      const newColor = lastUsedShapeColor ?? getRandomColor();
      setLastUsedShapeColor(newColor);      

      const generateButtons = (count) =>
        Array.from({ length: count }).map(() => ({
          _id: `temp-btn-${Date.now()}-${Math.random()}`,
          rotation: 0,
          color: null,
        }));

        switch (shapeType) {
          case 'hexagon':
            const hexagonShape = {
              shapeType: shapeType,
              x: shapeX || 0, // Ensure x is valid
              y: shapeY || 0, // Ensure y is valid
              radius: 70,
              color: newColor,
              buttons: [
                {
                  _id: `temp-btn-${Date.now()}-${Math.random()}`,
                  rotation: 0,
                  color: null,
                }, // center button
                ...generateButtons(6),
              ],
              draggable: true,
              rotation: 0,
              buttonLayout: "default",
              isDraggingShape: false, // Add tracking for drag state
            };
            addShape.mutate(hexagonShape);
            break;
          case 'rhombus':
            const rhombusCount = buttonLayout === "two-buttons" ? 2 : 1;
            const rhombusShape = {
              shapeType: shapeType,
              x: shapeX || 0, 
              y: shapeY || 0, 
              sideWidth: 70,
              color: newColor,
              buttons: generateButtons(rhombusCount),
              draggable: true,
              rotation: 0,
              buttonLayout: buttonLayout,
              isDraggingShape: false, // Add tracking for drag state

            };
            addShape.mutate(rhombusShape);
            break;
          case 'rectangle':
            const rectangleCount = buttonLayout === "one-button" ? 1 : 1; // Fallback to 1

            const rectangleShape = {
              shapeType: shapeType,
              x: shapeX || 0, 
              y: shapeY || 0,
              sideWidth: 70,
              sideHeight: 70,
              color: newColor,
              buttons: generateButtons(rectangleCount),
              draggable: true,
              rotation: 0,
              buttonLayout: buttonLayout,
              isDraggingShape: false, // Add tracking for drag state
            };
            addShape.mutate(rectangleShape);
            break;
          default:
            const extra = { shapeType };  

            showNotification({
              notification: t('errors.snackbar.NoShapeType'),
              type: 'error',
              extra, 
              isException: false,
            });

            break;
          }
      }
  };


  const handleShapeClick = (shapeId, e, msg) => {

    setSelectedItem({ type: 'panel', id: shapeId });

    const x = e.evt.clientX; // Relative to stage
    const y = e.evt.clientY; // Relative to stage

    //const bounds = e.target.getStage().container().getBoundingClientRect();
    //const x = e.evt.clientX - bounds.left; // Relative to stage
    //const y = e.evt.clientY - bounds.top; // Relative to stage

    useAppStore.setState((state) => ({
      shapePopovers: {
        ...state.shapePopovers,
        [shapeId]: {
          ...state.shapePopovers[shapeId], // Retain existing state if any
          open: true,
          x: x,
          y: y,
        },
      },
    }));

  };

  const handleCloseShapePopover = (shapeId) => {
    useAppStore.setState((state) => ({
      shapePopovers: {
        ...state.shapePopovers,
        [shapeId]: {
          ...state.shapePopovers[shapeId],
          open: false,
        },
      },
    }));
  };

const handleButtonClick = (buttonId, shapeId, e) => {

  e.cancelBubble = true; 
  setSelectedItem({ type: 'button', id: buttonId, shapeId: shapeId });

  if (stageRef.current && stageContainerRef.current) {
    const stage = stageRef.current;
    const containerRect = stageContainerRef.current.getBoundingClientRect();

    let pointerPos = stage.getPointerPosition();
    if (!pointerPos && e.evt.touches?.length > 0) {
      pointerPos = {
        x: e.evt.touches[0].clientX - containerRect.left,
        y: e.evt.touches[0].clientY - containerRect.top
      };
    }
    // Convert stage coordinates to UI screen coordinates for MUI Popover
    const popoverX = containerRect.left + pointerPos.x;
    const popoverY = containerRect.top + pointerPos.y;

    // Find the current word assigned to the button from the word list
    const assignedWord = wordList
    .flatMap(group => group.wordItems)
    .find(wordItem => wordItem.buttonId === buttonId);

    useAppStore.setState((state) => ({
      buttonPopovers: {
        ...state.buttonPopovers,
        [buttonId]: {
          ...state.buttonPopovers[buttonId], // Retain existing state if any
          open: true,
          x: popoverX,
          y: popoverY,
          selectedOption: assignedWord || "",
          inputValue: assignedWord ? assignedWord.text : "",
        },
      },
    }));
    
  } else {
    const extra = { stageContainerRef };  

    showNotification({
      notification: t('errors.snackbar.NoStageContainer'),
      type: 'error',
      extra, 
      isException: false,
    });
  }
};

// Close the popover
const handleClosePopover = (buttonId) => {

  setButtonPopovers(prev => ({
    ...prev,
    [buttonId]: {
        ...prev[buttonId],
        open: false
    }
}));
};

const handleInputChange = (buttonId, newInputValue) => {

  setButtonPopovers(prev => ({
      ...prev,
      [buttonId]: {
          ...prev[buttonId],
          inputValue: newInputValue
      }
  }));

};

/*
const calculateNextButtonLabel = () => {
  // Extract all button labels from all shapes' buttons
  const assignedLabels = shapes
    .flatMap(shape => shape.buttons.map(button => button.buttonLabel))
    .filter(Boolean)
    .map(label => Number(label)) // Ensure labels are numbers
    .sort((a, b) => a - b);

  // Find the lowest available label
  let nextLabel = 1;
  for (let i = 0; i < assignedLabels.length; i++) {
    if (assignedLabels[i] !== nextLabel) break;
    nextLabel++;
  }

  return nextLabel; // Return the next available button label
};


const handleOptionChange = async (buttonId, newValue) => {
  if (!newValue) return; // If no new value is selected, just return
  const currentWordItem = buttonPopovers[buttonId].selectedOption;

  if (currentWordItem && currentWordItem._id !== newValue._id) {
    //This case is current never true, because a button must be unassigned before it an be reassigned
    updateWordList('', currentWordItem._id, 'buttonId', 0);
    // Reclaim the button label number
    updateButton(selectedItem.shapeId, buttonId, 'buttonLabel', null);
  }

  // Calculate the next available button label using the provided function
  const nextLabel = calculateNextButtonLabel();

  //assign wordId to shape
  updateButton(selectedItem.shapeId, buttonId, 'wordId', newValue._id);
  //assign buttonId to wordList corresponding wordItem
  updateButton(selectedItem.shapeId, buttonId, 'buttonLabel', nextLabel);

  updateWordList('', newValue._id, 'buttonId', buttonId);

  //assign new button color
  const newColor = getRandomColor();

  updateButton(selectedItem.shapeId, buttonId, 'color', newColor);
  updateWordList('', newValue._id, 'color', newColor);


  // Update the popover state with the new selected option from the updated wordList
  const updatedSelectedOption = wordList
  .flatMap(group => group.wordItems)
  .find(wordItem => wordItem._id === newValue._id);

  setButtonPopovers(prev => ({
      ...prev,
      [buttonId]: {
        ...prev[buttonId],
        selectedOption: updatedSelectedOption,
        inputValue: updatedSelectedOption ? updatedSelectedOption.text : '',
        open: false
      }
  }));
};
*/

// Function to handle clicking anywhere on the stage
const handleStageClick = (e) => {
  if (!stageRef.current) {
    const extra = { stageRef, e };  

    showNotification({
      notification: t('errors.snackbar.NoStage'),
      type: 'error',
      extra, 
      isException: false,
    });

    return;
  }
  // Check if the clicked target is the stage itself and not any child shape
  const clickedOnEmpty = e.target === stageRef.current.getStage();
  if (clickedOnEmpty) {
    setSelectedItem({ type: '', id: '' }); // Reset selected shape ID
  }
};

  const handleRotateSelectedShape = () => {

    if (!selectedItem?.id) return;

    let rotatedShape = null;

    const shapeToUpdate = shapes?.find(shape => shape._id === selectedItem.id);
    if (!shapeToUpdate) return;

    let newRotation = shapeToUpdate.rotation || 0;

    newRotation += 30;
    newRotation %= 360;

    /*setShapes(prevShapes => {
      if (!Array.isArray(prevShapes)) return prevShapes;

      return prevShapes.map((shape) => {
        if (shape._id === selectedItem.id) {
          let newRotation = shape.rotation || 0;

          switch (shape.shapeType) {
            case 'hexagon':
              newRotation += 30;
              break;
            case 'rhombus':
              newRotation += 30;
              break;
            case 'rectangle':
              newRotation += 30;
              break;
            default:
              break;
          }

          rotatedShape = { ...shape, rotation: newRotation % 360 }; // Cache rotated shape
          return rotatedShape;
        }

        return shape;
      });
    });*/

    // Sync rotatedShape with backend if it exists
   // if (rotatedShape) {
     // updateShape(rotatedShape._id, 'rotation', rotatedShape.rotation);
   // }
    updateShape.mutate({ shapeId: shapeToUpdate._id, updates: [{field: 'rotation', value: newRotation }]});

    updateTooltips();
  };

  const handleColorChange = (newColor) => {
    if (selectedItem.type === 'panel') {
      updateSelectedShapeColor(newColor);
      setLastUsedShapeColor(newColor);
    } else if (selectedItem.type === 'button') {
      updateSelectedButtonColor(selectedItem.id, selectedItem.shapeId, newColor);
      setLastUsedButtonColor(newColor);
    }
  };

  const updateSelectedShapeColor = (newColor) => {

      // Check if the selected item is a panel
  if (selectedItem.type === 'panel') {
    // Update the color in the frontend state immediately
    /*ec setShapes(prevShapes => 
      prevShapes.map(shape => 
        shape._id === selectedItem.id 
          ? { ...shape, color: newColor } // Update the color for the selected shape
          : shape // Return the shape unmodified if it's not the selected one
      )
    );*/
    
      updateShape.mutate({ shapeId: selectedItem.id, updates:[{field: 'color', value: newColor}]});
    } else {
      const extra = { selectedItem, newColor };  

      showNotification({
        notification: t('errors.snackbar.NoShapeSelected'),
        type: 'error',
        extra, 
        isException: false,
      });
    }
  };

  const updateSelectedButtonColor = (buttonId, shapeId, newColor) => {
    updateButton.mutate({
      buttonId,
      updates: [{ field: "color", value: newColor }]
    });
  
    const buttonWordId = wordList.flatMap(group => group.wordItems).find(wordItem => wordItem.buttonId === buttonId)?._id;
    updateWordList.mutate({
      wordId: buttonWordId,
      updates: [
        {field: 'color', newValue: newColor}
      ]
    });
  };

  const isButtonAssigned = (buttonId) => {
    // Check through all word groups and their items for the buttonId
    return wordList.some(group => 
      group.wordItems.some(wordItem => wordItem.buttonId === buttonId)
    );
  };

  const handleDeleteSelectedShape = () => {

    if (selectedItem.type !== '' && selectedItem.id !== '') {
      // Filter out the selected shape based on its ID
      //updateShapes(shapes.filter(shape => shape._id !== selectedItem.id));
      const shape = shapes.find(s => s._id === selectedItem.id);

      if (shape) {
        deleteShape.mutate(selectedItem.id);

        // Reset the selectedItem since the selected shape has been deleted
        setSelectedItem({ type: '', id: '' });
        handleCloseShapePopover(selectedItem.id)
      }
    }
  };

  const handleUnassignSelectedButton = (buttonId) => {
    //unassignButton(selectedItem.shapeId, buttonId);
    unassignButton.mutate({ shapeId: selectedItem.shapeId, buttonIds: [buttonId] });

  // Clear the selected option in buttonPopovers
    setButtonPopovers(prev => {
      return {
        ...prev,
        [buttonId]: {
          ...prev[buttonId],
          selectedOption: null,
          inputValue: ''
        }
      };
    });
  };

  //Export to PDF
  const exportToPDF = () => {
    const stage = stageRef.current.getStage();
  
    // Get canvas dimensions
    const stageWidth = stage.width();
    const stageHeight = stage.height();
  
    // Create PDF with landscape mode
    const pdf = new jsPDF('l', 'px', [stageWidth + 60, stageHeight + 60]); // Extra margin
  
    // Define PDF dimensions
    const pdfWidth = pdf.internal.pageSize.width - 60; // Subtract margin
    const pdfHeight = pdf.internal.pageSize.height - 60;
  
    // Maintain aspect ratio for proper scaling
    const aspectRatio = stageWidth / stageHeight;
    let scaledWidth = pdfWidth;
    let scaledHeight = pdfHeight;
  
    if (stageWidth > stageHeight) {
      scaledHeight = pdfWidth / aspectRatio;
    } else {
      scaledWidth = pdfHeight * aspectRatio;
    }
  
    // Add the Soundboard (centered)
    pdf.addImage(
      stage.toDataURL({ pixelRatio: 2 }),
      'PNG',
      (pdf.internal.pageSize.width - scaledWidth) / 2,
      30, // Margin from top
      scaledWidth,
      scaledHeight
    );
  
    // Move to Word List
    pdf.addPage();
    pdf.setFontSize(18);

    // Dynamic column settings
    const maxColumns = Math.min(3, Math.floor(pdfWidth / 180)); // Adjust based on page width
    const colWidth = pdfWidth / maxColumns;
    const colMargin = 30;
    const colHeight = pdfHeight - 60;
    let x = colMargin;
    let y = colMargin;

    wordList.forEach((group, groupIndex) => {
      if (groupIndex % maxColumns === 0 && groupIndex > 0) {
        pdf.addPage();
        x = colMargin;
        y = colMargin;
      }

      pdf.setFont('helvetica', 'bold');
      pdf.text(group.groupName, x, y);
      y += 30;

      pdf.setFont('helvetica', 'normal');
      group.wordItems.forEach((wordItem) => {
        if (y + 20 > colHeight) {
          x += colWidth;
          y = colMargin;

          if (x + colWidth > pdfWidth) {
            pdf.addPage();
            x = colMargin;
          }
        }

        const button = shapes.flatMap(shape => shape.buttons).find(button => button._id === wordItem.buttonId);
        const buttonLabelText = button?.buttonLabel ? `${button.buttonLabel}` : '   ';

        pdf.text(`${buttonLabelText} ${wordItem.text}`, x, y);
        y += 20;
      });

      x += colWidth;
      y = colMargin;
    });

    pdf.save('Bwossy.pdf');
  };

  useEffect(() => {
    if (!soundboardId || !wordListId) {
      return; // ✅ Prevents running logic with null IDs
    }
  
    // ✅ Fetch soundboard only when IDs are available
    queryClient.invalidateQueries(['soundboard', soundboardId]);
  
  }, [soundboardId, wordListId]); // ✅ Only run when these values change
  
  useEffect(() => {
    // This logic only runs once when the component mounts
    /*getSoundboard();
    getWordList();*/

    return () => {
      // Cleanup
      stageRef.current = null;
      stageContainerRef.current = null;
    };
  }, []); 
  
  
  useEffect(() => {
    updateTooltips(); // ✅ Runs `updateTooltips` when visibility changes
  }, [assignedWordTooltipVisibility]);

  useEffect(() => {
      updateTooltips(); 
  }, [wordList, shapes, isDraggingShape]); // ✅ Separates tooltip updates from sessionStorage updates

  useEffect(() => {
    // Smooth transition effect for stage width
    const smoothResize = setTimeout(() => setCurrentStageWidth(stageWidth), 200);

    return () => clearTimeout(smoothResize);
  }, [stageWidth]);

  // Debounce background redraw
  useEffect(() => {
    const debouncedDraw = debounce(() => {
      drawTiledBackground();
    }, 300);

    debouncedDraw();

    return () => debouncedDraw.cancel();
  }, [currentStageWidth]);



  useLayoutEffect(() => {

    // Update the stageWidth when the component mounts or the window resizes
    const updateStageSize = () => {
      if (parentDivRef.current && buttonRowRef.current) {
        //calculate height of rows of input buttons
        //const buttonHeight = buttonRowRef.current.offsetHeight;

        const newWidth = parentDivRef.current.offsetWidth;
        const newHeight = parentDivRef.current.offsetHeight;//minus header height and button row
        //const newHeight = parentDivRef.current.offsetHeight - buttonHeight;//minus header height and button row
        setStageWidth(newWidth);
        setStageHeight(newHeight);

        // Update tooltips positions
        updateTooltips();
      }

    };

    window.addEventListener('resize', updateStageSize); // Add resize listener
    updateStageSize(); // Initial size update


  return () => {
    window.removeEventListener('resize', updateStageSize); // Cleanup listener
  };
}, [stageWidth, stageHeight]); // Empty dependency array means this effect runs once on mount
  
return (

    <div id="soundboard-column" className="soundboard-column" ref={parentDivRef}>

    <div style={{ position: 'relative', width: '100%', height: '0' }}>
      {/* Toolbar as an overlay */}
      <div
        style={{
          position: 'absolute',
          top: '5px', 
          left: '50%',
          transform: 'translateX(-50%)', // Moves div 50% of its own width to the left
          zIndex: 'var(--z-index-toolbar)', // Ensure toolbar is on top of the stage
        }}
      >

        <div className="toolbar-container" ref={buttonRowRef}>
            <div ref={dropdownRef} className="soundboard-dropdown">
              {/* Add panel button and dropdown */}
              <div className="toolbar-item toolbar-icon">
              <IconButton 
                aria-controls="add-panel-menu"
                aria-haspopup="true"
                variant="toolbar"
                onClick={handleOpenMenuAddPanel} 
                sx={{ 
                  fontSize: 'var(--font-button-size)', 
                  color: 'var(--text-primary)',
                  '&:hover': {
                    backgroundColor: 'var(--toolbar-button-color)', // Keep the same color on hover
                    transform: 'scale(1.05)', 
                  },
                }}
                aria-label={t('soundboard.addPanelAriaLabel')}
              >
                  <AddCircleRoundedIcon />
                  <span className="toolbar-text">{t('soundboard.addPanelLabel')}</span>
                </IconButton>
                <MuiMenu
                  id="add-panel-menu"
                  anchorEl={menuAnchorElAddPanel}
                  open={Boolean(menuAnchorElAddPanel)}
                  onClose={handleCloseMenuAddPanel}
                >
                  <MuiMenuItem
                    onClick={(e) => handleMenuItemClickAddPanel('hexagon', 'default', e)}
                    aria-label={t('soundboard.addHexagonLabel')}
                    sx={{ display: 'flex', alignItems: 'center', height: 80, gap: 2 }}
                  >
                    <Box sx={{ width: 60, height: 60, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <HexagonPreview style={{ width: 90, height: 90 }} />
                    </Box>
                    <Typography variant="body1" sx={{ textAlign: 'left' }}>
                      {t('soundboard.addHexagonLabel')}
                    </Typography>
                  </MuiMenuItem>

                  <MuiMenuItem
                    onClick={(e) => handleMenuItemClickAddPanel('rhombus', 'one-button', e)}
                    aria-label={t('soundboard.addRhombusOneLabel')}
                    sx={{ display: 'flex', alignItems: 'center', height: 80, gap: 2 }}
                  >
                    <Box sx={{ width: 60, height: 60, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <RhombusOneButtonPreview style={{ width: 90, height: 60 }} />
                    </Box>
                    <Typography variant="body1" sx={{ textAlign: 'left' }}>
                      {t('soundboard.addRhombusOneLabel')}
                    </Typography>
                  </MuiMenuItem>

                  <MuiMenuItem
                    onClick={(e) => handleMenuItemClickAddPanel('rhombus', 'two-buttons', e)}
                    aria-label={t('soundboard.addRhombusTwoLabel')}
                    sx={{ display: 'flex', alignItems: 'center', height: 80, gap: 2 }}
                  >
                    <Box sx={{ width: 60, height: 60, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <RhombusTwoButtonsPreview style={{ width: 90, height: 60 }} />
                    </Box>
                    <Typography variant="body1" sx={{ textAlign: 'left' }}>
                      {t('soundboard.addRhombusTwoLabel')}
                    </Typography>
                  </MuiMenuItem>

                  <MuiMenuItem
                    onClick={(e) => handleMenuItemClickAddPanel('rectangle', 'one-button', e)}
                    aria-label={t('soundboard.addRectangleLabel')}
                    sx={{ display: 'flex', alignItems: 'center', height: 80, gap: 2 }}
                  >
                    <Box sx={{ width: 60, height: 60, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <RectanglePreview style={{ width: 30, height: 30 }} />
                    </Box>
                    <Typography variant="body1" sx={{ textAlign: 'left' }}>
                      {t('soundboard.addRectangleLabel')}
                    </Typography>
                  </MuiMenuItem>
                </MuiMenu>
          
              </div>

              <div className="toolbar-item toolbar-icon">
                {/* Tooltip visibility button and menu */}
                <IconButton
                  aria-controls="tooltip-visibility-menu"
                  aria-haspopup="true"
                  variant="toolbar"
                  onClick={handleOpenMenuTooltip}
                  sx={{ 
                    fontSize: 'var(--font-button-size)', 
                    color: 'var(--text-primary)',
                    marginLeft: '10px',
                    '&:hover': {
                      backgroundColor: 'var(--toolbar-button-color)',
                      transform: 'scale(1.05)',
                    },
                  }}
                  aria-label={t('soundboard.tooltipVisibilityAriaLabel')}
                >
                  {visibilityOptions[assignedWordTooltipVisibility].icon}
                  <span className="toolbar-text">
                    {visibilityOptions[assignedWordTooltipVisibility].label}
                  </span>
                </IconButton>

                <MuiMenu
                  id="tooltip-visibility-menu"
                  anchorEl={anchorElTooltip}
                  open={Boolean(anchorElTooltip)}
                  onClose={handleCloseMenuTooltip}
                >
                  {Object.entries(visibilityOptions)
                    .filter(([key]) => key !== assignedWordTooltipVisibility)
                    .map(([key, { icon, label }]) => (
                      <MuiMenuItem
                        key={key}
                        onClick={() => handleMenuItemClickTooltip(key)}
                        aria-label={label}
                      >
                        {icon}
                        <span style={{ marginLeft: 8 }}>{label}</span>
                      </MuiMenuItem>
                    ))}
                </MuiMenu>
              </div>

              <div className="toolbar-item toolbar-icon">
                {/* Download button */}
                <IconButton 
                  variant="toolbar"
                  onClick={exportToPDF} 
                  aria-label={t('soundboard.downloadAriaLabel')}
                  sx={{
                    marginLeft: '10px',
                    '&:hover': {
                      backgroundColor: 'var(--toolbar-button-color-hover)',
                      transform: 'scale(1.05)',
                    },
                  }}
                >
                  <GetAppRoundedIcon />
                  
                  <span className="toolbar-text">{t('soundboard.downloadLabel')}</span>
                </IconButton>
              </div>
            </div>
          </div>
      </div>
    </div>  


      {/*<div className="soundboard-wrapper" />*/}
      <Stage 
        width={currentStageWidth} 
        height={stageHeight} 
        draggable={!isDraggingShape} // Prevent stage dragging when a shape is being dragged
        scaleX={stageScale}
        scaleY={stageScale}
        x={stagePos.x}
        y={stagePos.y}
        onPointerMove={(e) => {
          if (!e.target.hasName('petButton')) return;  // Prevent infinite loop
          e.target.fire('pointermove', e);
        }}
        onDragEnd={(e) => {
          setStagePos(e.currentTarget.position());
        }}
        onWheel={handleWheel} // Handles trackpad zoom
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        ref={node => {
          if (node) {
            stageRef.current = node;
            stageContainerRef.current = node.container();
          } else {
            stageRef.current = null;
            stageContainerRef.current = null;
          }
        }} 
        //onMouseMove={handleMouseMove} 
        onClick={handleStageClick}
      >
        <Layer>
          {/*draw infinite dotted grid background*/
          drawTiledBackground()}

          {shapes.map((shape) => {

          const adjustedX = centerX + shape.x; // Moves the origin to the center
          const adjustedY = centerY + shape.y; // Moves the origin to the center
        
          /** Array of buttons **/
          const newButtons = calculateButtonPositionsForTooltips(shape);

            switch(shape.shapeType) {
              case 'hexagon':
                return <Hexagon
                  shapeType={'hexagon'}
                  key={shape._id}
                  shapeId={shape._id}
                  stageWidth={stageWidth}
                  stageHeight={stageHeight}
                  x={adjustedX}
                  y={adjustedY}
                  radius={shape.radius}
                  color={shape.color}
                  rotation={shape.rotation}
                  buttons={newButtons}
                  buttonLayout={shape.buttonLayout}
                  //buttons={shape.buttons}
                  draggable={shape.draggable}
                  onDragStart={(e) => {
                    e.evt.preventDefault(); // Prevents unintended scrolling on mobile
                    handleDragStart(shape._id, e);
                  }}
                  onDragMove={(shapeId, e) => {
                    if (e.evt && e.evt.touches) {
                      e.evt.preventDefault(); // Prevents touch interference
                    }
                    handleDragMove(shape._id, e);
                  }}
                  
                  onDragEnd={(shapeId, e) => {
                    if (e.evt && e.evt.touches) {
                      e.evt.preventDefault(); // Prevents unintended jumps
                    }
                    handleDragEnd(shape._id, e);
                  }}
                  onClick={(shapeId, e) => handleShapeClick(shape._id, e)}
                  onButtonClick={handleButtonClick}
                  selected={selectedItem.type === 'panel' && selectedItem.id === shape._id}
                  selectedButton={selectedItem.type === 'button' ? selectedItem.id : null}
                  onMouseEnter={() => handleMouseEnterPanel(shape._id)}
                  onMouseLeave={handleMouseLeavePanel}
                  hovered={hoveredItem.type === 'panel' && hoveredItem.id === shape._id}
                  hoveredItem={hoveredItem}
                  // Pass down the handlers for the buttons as well
                  handleMouseEnterButton={handleMouseEnterButton}
                  handleMouseLeaveButton={() => handleMouseLeaveButton(shape._id)}
                />;
              case 'rhombus':
              case 'rhombus1':
              case 'rhombus2':
                return <Rhombus
                shapeType={'rhombus'}
                key={shape._id}
                shapeId={shape._id}
                stageWidth={stageWidth}
                stageHeight={stageHeight}
                x={adjustedX}
                y={adjustedY}
                sideWidth={shape.sideWidth}
                color={shape.color}
                rotation={shape.rotation}
                buttons={newButtons}
                buttonLayout={shape.buttonLayout}
                draggable={shape.draggable}
                onDragStart={(e) => {
                  e.evt.preventDefault(); // Prevents unintended scrolling on mobile
                  handleDragStart(shape._id, e);
                }}
                onDragMove={(shapeId, e) => {
                  if (e.evt && e.evt.touches) {
                    e.evt.preventDefault(); // Prevents touch interference
                  }
                  handleDragMove(shape._id, e);
                }}
                
                onDragEnd={(shapeId, e) => {
                  if (e.evt && e.evt.touches) {
                    e.evt.preventDefault(); // Prevents unintended jumps
                  }
                  handleDragEnd(shape._id, e);
                }}
                onClick={(shapeId, e) => handleShapeClick(shape._id, e)}
                onButtonClick={handleButtonClick}
                selected={selectedItem.type === 'panel' && selectedItem.id === shape._id}
                selectedButton={selectedItem.type === 'button' ? selectedItem.id : null}
                onMouseEnter={() => handleMouseEnterPanel(shape._id)}
                onMouseLeave={handleMouseLeavePanel}
                hovered={hoveredItem.type === 'panel' && hoveredItem.id === shape._id}
                hoveredItem={hoveredItem}
                handleMouseEnterButton={handleMouseEnterButton}
                handleMouseLeaveButton={() => handleMouseLeaveButton(shape._id)}
              />;
              case 'rectangle':
                return <Rectangle
                shapeType={'rectangle'}
                key={shape._id}
                shapeId={shape._id}
                stageWidth={stageWidth}
                stageHeight={stageHeight}
                x={adjustedX}
                y={adjustedY}
                sideWidth={70}
                sideHeight={70}
                color={shape.color}
                rotation={shape.rotation}
                buttons={newButtons}
                buttonLayout={shape.buttonLayout}
                draggable={shape.draggable}
                onDragStart={(e) => {
                  e.evt.preventDefault(); // Prevents unintended scrolling on mobile
                  handleDragStart(shape._id, e);
                }}
                onDragMove={(shapeId, e) => {
                  if (e.evt && e.evt.touches) {
                    e.evt.preventDefault(); // Prevents touch interference
                  }
                  handleDragMove(shape._id, e);
                }}
                
                onDragEnd={(shapeId, e) => {
                  if (e.evt && e.evt.touches) {
                    e.evt.preventDefault(); // Prevents unintended jumps
                  }
                  handleDragEnd(shape._id, e);
                }}
                onClick={(shapeId, e) => handleShapeClick(shape._id, e)}
                onButtonClick={handleButtonClick}
                selected={selectedItem.type === 'panel' && selectedItem.id === shape._id}
                selectedButton={selectedItem.type === 'button' ? selectedItem.id : null}
                onMouseEnter={() => handleMouseEnterPanel(shape._id)}
                onMouseLeave={handleMouseLeavePanel}
                hovered={hoveredItem.type === 'panel' && hoveredItem.id === shape._id}
                hoveredItem={hoveredItem}
                handleMouseEnterButton={handleMouseEnterButton}
                handleMouseLeaveButton={() => handleMouseLeaveButton(shape._id)}
              />;
              // Add cases for other shapes
              default:
                return null;
              }
            })}
            
            {tooltips.map(tooltip => (
              tooltip.visible && (
                <Group 
                  key={tooltip.buttonId} 
                  x={tooltip.x} 
                  y={tooltip.y}
                  listening={false} // Disable event listening for the entire Group
                >
                  <Rect
                    x={0}
                    y={0}
                    width={measureTextWidth(tooltip.text, 12) + tooltipPadding * 2} // Adjust width based on text length
                    height={10+ tooltipPadding * 2} // Adjust height based on font size and padding
                    fill={tooltipBackgroundColor}
                    cornerRadius={tooltipCornerRadius}
                    shadowBlur={10}
                    shadowOpacity={0.3}
                    listening={false} // Disable event listening for the Rect
                  />
                  <Text
                    x={tooltipPadding}
                    y={tooltipPadding}
                    fill={tooltipTextColor}
                    text={tooltip.text}
                    fontSize={tooltipFontSize}
                    fontFamily={fontPrimary}
                    listening={false} // Disable event listening for the Text
                  />
                </Group>
              )
            ))}
            
         </Layer>
      </Stage>
      { 
      // Shapes popover      
       Object.keys(shapePopovers).map(shapeId => (
        shapePopovers[shapeId].open && (
          <ControlledMenu
            key={shapeId}
            className={'popover-menu'}
            //style={{ borderRadius: '0 10px 15px 0' }} // Inline style for custom border-radius
            state={shapePopovers[shapeId].open ? 'open' : 'closed'}
            anchorPoint={{ x: shapePopovers[shapeId].x, y: shapePopovers[shapeId].y }}
            onClose={() => handleCloseShapePopover(shapeId)}
            direction="right"
          >        
                <MenuItem 
                  onClick={(e) => {handleRotateSelectedShape(shapeId); e.keepOpen = true;}}
                  style={{ 
                    fontFamily: 'var(--font-primary)', 
                    fontWeight: 'var(--font-weight-normal)'
                  }}
                  aria-label={t('soundboard.popovers.rotate')}
                >
                  <ListItemIcon>
                    <RotateRight />
                  </ListItemIcon>
                  <ListItemText 
                    primary={t('soundboard.popovers.rotate')}
                    primaryTypographyProps={{
                      fontFamily: 'var(--font-primary)', // Use the custom font
                      fontSize: 'inherit', // Ensure consistent font size
                      fontWeight: 'inherit', // Ensure consistent font weight
                    }}              
                  />
                </MenuItem>
                
                <SubMenu label={
                  <div style={{ display: 'flex', alignItems: 'left' }}>
                    <ListItemIcon>
                      <Palette />
                    </ListItemIcon>
                    <ListItemText 
                      primary={t('soundboard.popovers.changeColor')}
                      primaryTypographyProps={{
                        fontFamily: 'var(--font-primary)', // Use the custom font
                        fontSize: 'inherit', // Ensure consistent font size
                        fontWeight: 'inherit', // Ensure consistent font weight
                      }}
                    />
                  </div>
                }
                aria-label={t('soundboard.popovers.changeColor')}
                >
                  <div style={{ padding: '20px' }}>
                    <CirclePicker 
                      colors={colorOptions}
                      onChangeComplete={(color) => handleColorChange(color.hex)} 
                    />
                  </div>
                </SubMenu>

              <MenuItem 
                onClick={() => handleDeleteSelectedShape()}
                style={{ 
                  fontFamily: 'var(--font-primary)', 
                  fontWeight: 'var(--font-weight-normal)' 
                }}
                aria-label={t('soundboard.popovers.delete')}
              >
                <ListItemIcon>
                  <Delete />
                </ListItemIcon>
                <ListItemText 
                  primary={t('soundboard.popovers.delete')}
                  primaryTypographyProps={{
                    fontFamily: 'var(--font-primary)', // Use the custom font
                    fontSize: 'inherit', // Ensure consistent font size
                    fontWeight: 'inherit', // Ensure consistent font weight
                  }}            
                />
              </MenuItem>
          </ControlledMenu>
        )
      ))}

      { 
      // Buttons popover
      Object.keys(buttonPopovers)
      .filter(buttonId => buttonPopovers[buttonId]?.open) // ✅ Filter only open popovers  
      .map(buttonId => (
        buttonPopovers[buttonId].open && (
        <ControlledMenu
          key={`${buttonId}`}
          state={buttonPopovers[buttonId].open ? 'open' : 'closed'}
          anchorPoint={{ x: buttonPopovers[buttonId]?.x || 0, y: buttonPopovers[buttonId]?.y || 0 }}
          direction="right"
          onClose={() => handleClosePopover(buttonId)}
        >
        <FocusableItem>
          {({ ref }) => (
              <Autocomplete
              ref={ref}
              disabled={(selectedItem.type==='button' && isButtonAssigned(selectedItem.id))}
              value={buttonPopovers[buttonId]?.selectedOption || null}
              onChange={(event, newValue) => {
                const soundboardId = useAppStore.getState().soundboardId;
                const shapes = queryClient.getQueryData(["soundboard", soundboardId])?.shapes || [];
                const nextLabel = calculateNextButtonLabel(shapes);
                const newColor = lastUsedButtonColor ?? getRandomColor();
                setLastUsedButtonColor(newColor);

                handleOptionChange.mutate({ buttonId, newValue, nextLabel, newColor });
              }}
              inputValue={buttonPopovers[buttonId]?.inputValue || ''}
              onInputChange={(event, newInputValue) => {
                handleInputChange(buttonId, newInputValue);
                handleHoverLeave();
              }}
              options={wordList.flatMap(group => group.wordItems)}
              getOptionLabel={(option) => option.text || t('soundboard.popovers.noLabel')}
              filterOptions={(options, params) => {
                const filtered = options.filter(option => {
                  // Ensure buttonId is 0 (unassigned) and filter based on the input text
                  return option.buttonId === '0' && option.text.toLowerCase().includes(params.inputValue.toLowerCase());
                });
                // Re-include the selected option if it's not in the filtered list
                const selectedOption = buttonPopovers[buttonId]?.selectedOption || null;
                if (selectedOption && !filtered.some(opt => opt._id === selectedOption._id)) {
                  filtered.push(selectedOption);
                }
                return filtered; // Ensure the filtered array is returned
              }}
              isOptionEqualToValue={(option, value) => option.text === value.text}
              renderOption={(props, option) => {        
                return (
                  <li {...props} style={{ opacity: option.buttonId !== 0 ? 0.5 : 1 }}>
                    {option.text ? option.text : option} {/* Ensure it doesn't break if option is a simple value */}
                  </li>
                );
              }}
              renderInput={(params) => <TextField {...params} label={t('soundboard.popovers.assignWord')} />}
              sx={{ p: 0, width: 200 }}
            />
            )}
          </FocusableItem>
          <SubMenu 
            disabled={(!isButtonAssigned(selectedItem.id))}
            label={
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <ListItemIcon>
                <Palette />
              </ListItemIcon>
              <ListItemText 
                primary={t('soundboard.popovers.changeColor')} 
                primaryTypographyProps={{
                  fontFamily: 'var(--font-primary)', // Use the custom font
                  fontSize: 'inherit', // Ensure consistent font size
                  fontWeight: 'inherit', // Ensure consistent font weight
                }}
                aria-label={t('soundboard.popovers.changeColor')} 
              />
            </div>
          }>
            <div style={{ padding: '20px' }}>
              <CirclePicker 
                colors={colorOptions}
                onChangeComplete={(color) => handleColorChange(color.hex)} 
              />
            </div>
          </SubMenu>
            <MenuItem 
              disabled={(!isButtonAssigned(selectedItem.id))}
               onClick={() => handleUnassignSelectedButton(buttonId)}
            >
                <ListItemIcon>
                  <LinkOffIcon />
                </ListItemIcon>
                <ListItemText 
                  primary={t('soundboard.popovers.unassignWord')} 
                  primaryTypographyProps={{
                    fontFamily: 'var(--font-primary)', // Use the custom font
                    fontSize: 'inherit', // Ensure consistent font size
                    fontWeight: 'inherit', // Ensure consistent font weight
                  }}
                />

            </MenuItem>
        </ControlledMenu>
      )))}      

      <div
        style={{
          position: 'absolute',
          right: 0,
          top: `${Math.max(stageHeight / 2, 150)}px`,
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
        }}
      >
        <IconButton onClick={handleZoomIn} aria-label="zoom-in" size="small">
          <ZoomIn />
        </IconButton>
        <IconButton onClick={handleZoomOut} aria-label="zoom-out" size="small">
          <ZoomOut />
        </IconButton>
        <IconButton onClick={handleRecenter} aria-label="re-center" size="small">
          <CenterFocusStrong />
        </IconButton>
      </div>

    </div>    

  );
}

export default Soundboard;
